<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link
            :to="'/' + authUser.userable_type + '/library'"
            style="color: #8cc63f !important"
          >
            Library
          </router-link>
        </li>
      </ol>
    </div>
        <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <div style="display: flex; justify-content: space-between" class="col-10">
        <span
          class="col-3"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            color: gray;
          "
        >
          <i
            class="fa fa-filter"
            style="font-size: 15px; color: #8cc63f; margin-right: 5px"
          ></i>
          Filter
        </span>
        <span class="col-5">
          <input
            type="text"
            class="form-control"
            placeholder="Keyword"
            style="padding: 10px"
          />
        </span>
      </div>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="toggleUploadMediaFileModal()"
      >
        <button
          style="width: 115px; border-radius: 60px; height: 115px"
          class="btn btn-success"
        >
          <i class="fa fa-upload" style="font-size: 50px"></i>
        </button>
      </div>
    </div>

    <div style="display: flex; justify-content: center; margin-top: 50px">
      <pagination
        :data="mediaFiles"
        scope="props"
        itemTemplate="mediaFile"
        :classes="['mediaClass', 'col-12']"
      ></pagination>
    </div>
  </div>
</template><script>
import FileUploader from "../common/FileUploader.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import MediaFilesFilter from "../../filters/MediaFilesFilter";
import Pagination from "../common/Pagination.vue";
import Modal from "../../components/Modal.vue";
export default {
  name: "mediaFile",
  data() {
    return {
      selectedMediaFileId: null,
      showMediaFileModal: false,
      columns: [],
    };
  },
  components: {
    
    Pagination,
    Modal,
    FileUploader,
  },
  created: function () {
    var mediaFileFilter = MediaFilesFilter();
    this.$store.dispatch("searchMediaFiles", {
      filter: mediaFileFilter,
      resultMode: "paginated",
    });
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      mediaFiles: (state) => state.mediaStore.mediaSearch.mediaFiles,
      createMediaFileStatus: (state) =>
        state.mediaStore.mediaCreate.createMediaStatus,
      updateMediaFileStatus: (state) =>
        state.mediaStore.mediaUpdate.updateMediaStatus,
      deleteMediaFileStatus: (state) =>
        state.mediaStore.mediaDelete.deleteMediaStatus,
    }),
  },
  methods: {
    init() {
      this.selectedMediaFileId = null;
      this.showMediaFileModal = false;
      this.$store.dispatch("searchMediaFile").then(() => {
        this.filterMediaFiles();
      });
    },
    filterMediaFiles() {},
    handleSave(mediaFile) {
      this.createMediaFile(mediaFile);
    },
    createMediaFile(mediaFile) {
      this.$store.dispatch("createMediaFile", mediaFile);
    },
    updateMediaFile(mediaFile) {
      this.$store.dispatch("updateMediaFile", mediaFile);
    },
    deleteMediaFile(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this mediaFile?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if(result.value) {
          this.$store.dispatch("deleteMediaFile", id);
        }
      });
    },
    toggleUploadMediaFileModal() {
      this.showMediaFileModal = !this.showMediaFileModal;
    },
  },
  watch: {
    createMediaFileStatus() {
      if (this.createMediaFileStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "MediaFile has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createMediaFileStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "MediaFile creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updateMediaFileStatus() {
      if (this.updateMediaFileStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "MediaFile has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updateMediaFileStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "MediaFile update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    deleteMediaFileStatus() {
      if (this.deleteMediaFileStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "MediaFile has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.deleteMediaFileStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "MediaFile delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
 <style>
.mediaClass {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
}
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.btn-success {
  color: #fff;
  background-color: #8cc63f;
  border-color: #8cc63f;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/library.vue